export type ApiErrorDetail = {
  key?: string | null;
  value?: string | null;
};

export type ApiValidationError = Error & {
  errorCode?: number | null;
  errorDetails?: Array<ApiErrorDetail> | null;
};

export type ApiErrorBody = {
  errorCode?: number | null;
  errorText?: string | null;
  errorDetails?: Array<ApiErrorDetail> | null;
};

function isObjectWithKey<T extends string>(
  value: unknown,
  key: T
): value is Record<T, unknown> {
  return typeof value === 'object' && value !== null && key in value;
}

export function isApiErrorBody(value: unknown): value is ApiErrorBody {
  return isObjectWithKey(value, 'errorCode') || isObjectWithKey(value, 'errorText');
}
